import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	// Map of appId -> boolean. Absence of a key means "not enabled" (fail-closed).
	enabledApps: {},
	isLoading: false,
	// True once a fetch has resolved (success or empty). Guards must wait for
	// this before denying access, otherwise they'd flash "subscribe" on boot.
	isLoaded: false,
	error: false,
};

const enabledAppsSlice = createSlice({
	name: 'enabledApps',
	initialState,
	reducers: {
		setEnabledAppsLoading: (state) => {
			state.isLoading = true;
			state.error = false;
		},
		storeEnabledApps: (state, action) => {
			state.enabledApps = action.payload;
			state.isLoading = false;
			state.isLoaded = true;
			state.error = false;
		},
		setEnabledAppsError: (state) => {
			state.isLoading = false;
			state.isLoaded = true;
			state.error = true;
		},
	},
});

export const selectEnabledApps = (state) => state.enabledApps;

export const selectIsAppEnabled = (appId) => (state) =>
	state.enabledApps.enabledApps[appId] === true;

export const { setEnabledAppsLoading, storeEnabledApps, setEnabledAppsError } =
	enabledAppsSlice.actions;

export default enabledAppsSlice.reducer;
